import { Controller } from "stimulus"

export default class extends Controller {

  initialize() {
    this.setUnmatchModalFocus();
  }

  setUnmatchModalFocus() {
    // When the modal is shown, set the focus to the confirm button
    // This is necessary for screen readers, as it allows users to immediately interact with the modal
    var unmatchModal = document.getElementById('unmatchModal');
    var confirmUnmatch = document.getElementById('confirmUnmatch');
    if (unmatchModal && confirmUnmatch) {
      unmatchModal.addEventListener('shown.bs.modal', function () {
        confirmUnmatch.focus();
      })
    }
  }
}